<template>
  <div>
    <div class="d-flex justify-content-between mb-2">
      <h3 class="card-title">Lista de Aviso de privacidad</h3>
      <div class="d-flex">
        <PrimaryButton class="btn btn-primary ms-auto" data-toggle="modal" data-target="#privacyPolicyModal"
          @click="privacyStore.openModal">
          Generar
        </PrimaryButton>
      </div>
    </div>

    <div class="d-flex mt-3 mb-3">
      <input type="text" class="form-control" placeholder="Buscar Aviso de privacidad..."
        v-model="privacyStore.searchString" />
    </div>

    <div>
      <PrivacyPolicyTable :policies="privacyStore.paginatedPolicies" @sort="privacyStore.sortBy($event)"
        @edit="privacyStore.editPolicy($event)" />

      <Pagination v-if="privacyStore.filteredPolicies.length > privacyStore.itemsPerPage"
        :list="privacyStore.filteredPolicies" :items-per-page="privacyStore.itemsPerPage"
        :current-page="privacyStore.currentPage" @current-page="privacyStore.setCurrentPage($event)" />
    </div>

    <Modal modal-id="privacyPolicyModal" :customClass="'modal-xl'">
      <div class="modal-header">
        <h4 class="modal-title">Aviso de privacidad</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="privacyStore.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body">
          <div class="row">
            <div class="col-12 mb-4">
              <div class="col-12 col-md-3 col-lg-3 content-col">
                <label for="applicationSelect" class="mb-0 font-weight-lb">Solicitud:</label>
              </div>

              <div class="col-12 col-md-4 col-lg-4" v-show="!privacyStore.isEdit">
                <select id="applicationSelectSolAP" v-model="privacyStore.selectedApplication"
                  class="form-select selectpicker border-dark" data-width="100%" data-live-search="true"
                  :disabled="!privacyStore.loanApplicationsOptions.length" title="Selecciona solicitud...">
                  <option value="" disabled>Selecciona solicitud</option>
                  <option v-for="application in privacyStore.loanApplicationsOptions" :key="application.id"
                    :value="application">
                    {{ application.referenceNumber }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-4 col-lg-4" v-show="privacyStore.isEdit">
                <label for="applicationSelect" class="mb-0 font-weight-lb">
                  {{ privacyStore.numReference }}
                </label>
              </div>
            </div>
          </div>
          <PrivacyPolicy />
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="privacyStore.closeModal">
          {{ $getLocaleMessage('buttons', 'cancel') }}
        </button>
      </div>
    </Modal>
  </div>
</template>

<script setup>
import { usePrivacyPolicyStore } from '@/pinia/LoanApplications/Legal/usePrivacyPolicyStore.module';
import { nextTick, onMounted, computed, watch } from "vue";
import Modal from '@/Components/Bootstrap/Modal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import PrivacyPolicy from '@/Components/Forms/LoanApplications/Legal/PrivacyPolicy.vue';
import PrivacyPolicyTable from '@/Components/Tables/PrivacyPolicyTable.vue';
import Pagination from '@/Components/Bootstrap/Pagination.vue';

const privacyStore = usePrivacyPolicyStore();
const getSelectAP = () => $('#applicationSelectSolAP');

// Watcher para isModalOpen
watch(
  () => privacyStore.isModalOpen,
  (newValue) => {
    if (!newValue) {
      // Resetear el selectpicker initializeSelectPicker();
      nextTick(() => {
        const select = getSelectAP();
        if (select.length) {
          select.val('').selectpicker('refresh');
        }
      });
    }
  },
);

// Watcher para actualizar nombre y fecha cuando cambia selectedApplication
watch(
  () => privacyStore.selectedApplication,
  (newApp) => {
    if (newApp && newApp.prospectus?.generalInformation) {
      if (newApp.prospectus.personType.id === 1) {
        const { firstName, lastName, mothersMaidenName } = newApp.prospectus.generalInformation;
        privacyStore.nombre = `${firstName || ''} ${lastName || ''} ${mothersMaidenName || ''}`.trim();
      } else {
        const { businessName } = newApp.prospectus.generalInformation;
        const { firstName, lastName, mothersMaidenName } = newApp.prospectus.legalRepresentative;
        privacyStore.nombre = `${businessName || ''} | ${firstName || ''} ${lastName || ''} ${mothersMaidenName || ''}`.trim();
      }
    }

    if(!privacyStore.isEdit){
      privacyStore.fecha = '';
    }

  },
  { deep: true, immediate: true } // Agrega esto para que se ejecute al montar el componente immediate
);

// Watcher para las opciones del select
watch(
  () => privacyStore.loanApplicationsOptions,
  async (newOptions) => {
    if (newOptions.length > 0 && privacyStore.isModalOpen) {
      initializeSelectPicker();
    }
  },
  { deep: true }
);

// Inicializa el selectpicker
const initializeSelectPicker = () => {
  nextTick(() => {
    const select = getSelectAP();
    if (select.length) {
      select.selectpicker('refresh');
      if (!privacyStore.selectedApplication) {
        select.selectpicker('val', '');
      }
    }
  });
};

// Cargar avisos de privacidad al montar el componente
onMounted(async () => {
  await privacyStore.fetchPrivacyPolicies();
  await privacyStore.filterBureauLoanApplications();
  initializeSelectPicker();
});
</script>